import path from 'node:path'
import * as p from '@clack/prompts'
import type { ListPluginsCommandOptions } from '@core-engine/commands/runtime.js'
import { resolveConfig } from '@next-adapter/config.js'
import { listAvailablePlugins } from '@next-adapter/plugin-runtime.js'

export async function runListPluginsCommand(options: ListPluginsCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()
  const config = await resolveConfig(cwd)
  const installedPlugins = new Set(config.plugins.installed)

  const lines = listAvailablePlugins().map((plugin) => {
    const status = installedPlugins.has(plugin.id) ? 'installed' : 'available'
    return `${plugin.id.padEnd(10)} ${status.padEnd(10)} ${plugin.kind.padEnd(12)} ${plugin.description}`
  })

  p.note(lines.join('\n'), 'BetterStart plugins')
  p.outro(`${installedPlugins.size} installed, ${lines.length - installedPlugins.size} available`)
}
